import './PA&SHelp.scss';
export default function PASHelp(props: any) {
    return <table className="pas-table">
        <tr className="pas-header">
            <td>Benefit</td>
            <td>Level 1</td>
            <td>Level 2</td>
        </tr>
        <tr>
            <td>Accidental Death</td>
            <td>&pound;25,000</td>
            <td>&pound;50,000</td>
        </tr>
        <tr>
            <td>Permanent Total Disability</td>
            <td>&pound;50,000</td>
            <td>&pound;100,000</td>
        </tr>
        <tr>
            <td>Quadriplegia</td>
            <td>&pound;100,000</td>
            <td>&pound;200,000</td>
        </tr>
        <tr>
            <td>Paraplegia</td>
            <td>&pound;50,000</td>
            <td>&pound;100,000</td>
        </tr>
        <tr>
            <td>Permanent loss of sight in both eyes</td>
            <td>&pound;25,000</td>
            <td>&pound;50,000</td>
        </tr>
        <tr>
            <td>Permanent loss of use of two limbs</td>
            <td>&pound;25,000</td>
            <td>&pound;50,000</td>
        </tr>
        <tr>
            <td>Permanent loss of sight in one eye</td>
            <td>&pound;12,500</td>
            <td>&pound;25,000</td>
        </tr>
        <tr>
            <td>Permanent loss of use of one limb</td>
            <td>&pound;12,500</td>
            <td>&pound;25,000</td>
        </tr>
        <tr>
            <td>Permanent loss of speech</td>
            <td>&pound;12,500</td>
            <td>&pound;25,000</td>
        </tr>
        <tr>
            <td>Permanent loss of hearing in both ears</td>
            <td>&pound;12,500</td>
            <td>&pound;25,000</td>
        </tr>
        <tr>
            <td>Permanent loss of hearing in one ear</td>
            <td>&pound;5,000</td>
            <td>&pound;10,000</td>
        </tr>
        <tr>
            <td>Burns</td>
            <td>&pound;1,250</td>
            <td>&pound;2,500</td>
        </tr>
        <tr className="pas-header">
            <td>Permanent loss of use of:</td>
            <td></td>
            <td></td>
        </tr>
        <tr>
            <td>A shoulder, elbow, hip, knee, thumb, wrist or ankle</td>
            <td>&pound;5,000</td>
            <td>&pound;10,000</td>
        </tr>
        <tr>
            <td>Any finger or big toe</td>
            <td>&pound;2,500 </td>
            <td>&pound;5,000</td>
        </tr>
        <tr>
            <td>Any other toe</td>
            <td>&pound;500</td>
            <td>&pound;1,000</td>
        </tr>
        <tr className="pas-header">
            <td>Hospitalisation:</td>
            <td></td>
            <td></td>
        </tr>
        <tr>
            <td>Hospitalisation (Maximum 45 days and after a minimum 24 hours)</td>
            <td>&pound;50</td>
            <td>&pound;100</td>
        </tr>
        <tr>
            <td>Extended hospitalisation (for stays longer than 14 days) </td>
            <td>&pound;500</td>
            <td>&pound;1,000</td>
        </tr>
        <tr className="pas-header">
            <td>A Major Fracture of:</td>
            <td></td>
            <td></td>
        </tr>
        <tr>
            <td>Upper leg; vertebral body; Pelvis; Skull.</td>
            <td>&pound;250</td>
            <td>&pound;500</td>
        </tr>
        <tr>
            <td>Vertebra other than vertebral body; lower leg; lower jaw; breastbone; shoulder blade; kneecap; upper arm; lower arm.</td>
            <td>&pound;125</td>
            <td>&pound;250</td>
        </tr>
        <tr>
            <td>Lower leg; hand (metacarpals); foot (metatarsals); clavicle; coccyx; wrist (carpals) & Colles' fracture ankle (tarsals) & Pott's fracture.</td>
            <td>&pound;50</td>
            <td>&pound;100</td>
        </tr>
        <tr className="pas-header">
            <td>Dislocation of:</td>
            <td></td>
            <td></td>
        </tr>
        <tr>
            <td>Spine; back; hip.</td>
            <td>&pound;125</td>
            <td>&pound;250</td>
        </tr>
        <tr>
            <td>Knee; ankle; shoulder or collar bone; elbow; wrist.</td>
            <td>&pound;50</td>
            <td>&pound;100</td>
        </tr>
        <tr>
            <td>Any other joint</td>
            <td>&pound;25</td>
            <td>&pound;50</td>
        </tr>
    </table>
}